/**
 * @generated SignedSource<<fe80581755c58fd440e52462e25c7717>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselThumb_sortedPhoto$data = {
  readonly alt: string | null;
  readonly masterOrZoomPath: string | null;
  readonly " $fragmentType": "HeroCarouselThumb_sortedPhoto";
};
export type HeroCarouselThumb_sortedPhoto$key = {
  readonly " $data"?: HeroCarouselThumb_sortedPhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_sortedPhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselThumb_sortedPhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};

(node as any).hash = "76b78166bc14386b866f24c49b1fd641";

export default node;
